import React from 'react';
import styled from 'styled-components';
import { object, string, func } from 'prop-types';
import ReactMarkdown from 'react-markdown';

import withVisibilityToggle from '../../core/enhancements/withVisibilityToggle';
import CommunicationCard from './CommunicationCard';
import PhoneCommunicationCard from './PhoneCommunicationCard';
import Divider from './Divider';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-bottom: 42px;
  background-color: ${({ bgColor }) => bgColor};
`;

const Title = styled.h2`
  font-family: "Nunito Sans", sans-serif;
  font-size: 24px;
  line-height: 1.33;
  text-align: center;
  margin-bottom: 8px;
  color: #4a4a4a;
`;

const Description = styled(ReactMarkdown)`
  * {
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    line-height: 1.43;
    color: #4a4a4a;
    text-align: center;
  }

  strong {
    font-weight: bold;
    display: block;
  }

  @media (min-width: 1000px) {
    strong {
      display: inline;
    }
  }
`;

const CommunicationCardList = styled.div`
  @media (min-width: 1000px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 1000px;
  }
`;

const CommunicationBox = ({
  posName, telesales, bgColor, paddingTop, handleClick,
}) => (
  <Container id="insidesales" name="insidesales" bgColor={bgColor} paddingTop={paddingTop}>
    <Divider />
    <Title>{telesales.title}</Title>
    <Description>{`${telesales.subtitle} ${telesales.subtitle2}`}</Description>
    <CommunicationCardList>
      {telesales.whatsapp && (
      <CommunicationCard
        icon="icon-circle-whatsapp"
        text="Whatsapp"
        button="Enviar Mensagem"
        href={
          telesales.whatsapp.url
            ? telesales.whatsapp.url
            : 'https://api.whatsapp.com/send?phone=5511953106412&text=Ol%C3%A1!%20Tenho%20d%C3%BAvidas%20sobre%20os%20planos%20profissionais%20da%20OLX.%20'
        }
        type="whatsapp"
        posName={posName}
        handleClick={handleClick}
      />
        )}
      {telesales.phones && (
      <PhoneCommunicationCard
        icon="icon-circle-phone"
        text="Telefone"
        button="Ver Telefones >"
        phones={telesales.phones}
        type="phones"
        posName={posName}
        handleClick={handleClick}
      />
        )}
      {telesales.collector && (
      <CommunicationCard
        icon="icon-circle-headset-blue"
        text="A gente te liga"
        button="Enviar Mensagem"
        href={
          telesales.collector.url
            ? `${telesales.collector.url}?referral=POS-MKT`
            : 'https://www.olx.com.br/lead_collector?referral=POS-MKT'
        }
        type="lead-collector"
        posName={posName}
        handleClick={handleClick}
      />
        )}
    </CommunicationCardList>
  </Container>
);

CommunicationBox.propTypes = {
  posName: string,
  telesales: object.isRequired,
  bgColor: string,
  paddingTop: string,
  handleClick: func.isRequired,
};

CommunicationBox.defaultProps = {
  posName: '',
  bgColor: '#f6f6f6',
  paddingTop: '64px',
};

export default withVisibilityToggle(CommunicationBox);
